/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";

import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import Dropdown from "./dropdown";
import { v4 as uuidV4 } from "uuid";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "center",
  padding: "8px",
  fontWeight: 400,
};

const titleStyle = {
  textAlign: "right",
  paddingRight: 20,
  background: "#ddeff3",
  fontWeight: "bold",
};

const Th = ({ children, styles, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, fontSize: "16px", ...styles }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px" }}>
      {children}
    </th>
  );
};

const provinceOption = [
  {
    value: "An giang",
    label: "An giang",
  },
  {
    value: "Cần thơ",
    label: "Cần thơ",
  },
  {
    value: "TP Hồ Chí Minh",
    label: "TP Hồ Chí Minh",
  },
];

const districtOption = [
  {
    value: "Châu thành",
    label: "Châu thành",
  },
  {
    value: "Long xuyên",
    label: "Long xuyên",
  },
  {
    value: "Chợ mới",
    label: "Chợ mới",
  },
];

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
];

const typeOption = [
  {
    value: "Trụ sở chính",
    label: "Trụ sở chính",
  },
  {
    value: "Chi nhánh",
    label: "Chi nhánh",
  },
];

const content = {
  item1: [
    {
      isDeleted: false,
      id: {
        value: uuidV4(),
        bg: false,
      },
      type: {
        type: "select",
        value: null,
        bg: false,
      },
      companyName: {
        type: "input",
        value: null,
        bg: false,
      },
      taxId: {
        type: "input",
        value: null,
        bg: false,
      },
      province: {
        type: "select",
        value: null,
        bg: false,
      },
      district: {
        type: "select",
        value: null,
        bg: false,
      },
      taxAuthoritiesProvince: {
        type: "select",
        value: null,
        bg: false,
      },
      taxAuthoritiesDistrict: {
        type: "select",
        value: null,
        bg: false,
      },
      fuelName: {
        type: "input",
        value: null,
        bg: false,
      },
      DVT: {
        type: "input",
        value: null,
        bg: true,
      },
      quantityFuel: {
        type: "input",
        value: 0,
        bg: false,
      },

      PercentQuantityFuel: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceProtectTaxPaid: {
        type: "input",
        value: 0,
        bg: false,
      },
    },
  ],
};
export default function ProtectResourceTable1({ formData, setFieldValue }) {
  const [data, setData] = useState(content);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value, type, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        console.log(item);
        if (item.id.value === id) {
          return { ...item, [name]: { type: item[name]?.type, value } };
        }
        return item;
      }),
    }));
  };

  const addNewRow = (item) => {
    const newRow = {
      isDeleted: true,
      id: {
        value: uuidV4(),
        bg: false,
      },
      type: {
        type: "select",
        value: null,
        bg: false,
      },
      companyName: {
        type: "input",
        value: null,
        bg: false,
      },
      taxId: {
        type: "input",
        value: null,
        bg: false,
      },
      province: {
        type: "select",
        value: null,
        bg: false,
      },
      district: {
        type: "select",
        value: null,
        bg: false,
      },
      taxAuthoritiesProvince: {
        type: "select",
        value: null,
        bg: false,
      },
      taxAuthoritiesDistrict: {
        type: "select",
        value: null,
        bg: false,
      },
      fuelName: {
        type: "input",
        value: null,
        bg: false,
      },
      DVT: {
        type: "input",
        value: null,
        bg: true,
      },
      quantityFuel: {
        type: "input",
        value: 0,
        bg: false,
      },

      PercentQuantityFuel: {
        type: "input",
        value: 0,
        bg: false,
      },
      resourceProtectTaxPaid: {
        type: "input",
        value: 0,
        bg: false,
      },
    };

    setData((prev) => ({ ...prev, [item]: [...prev[item], newRow] }));
  };

  const handleDelete = (type, index) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type].filter((item) => item.id.value !== index),
    }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th styles={{ textAlign: "center", width: "150px" }} rowSpan="2">
                Loại
              </Th>
              <Th styles={{ textAlign: "center", width: "130px" }} rowSpan="2">
                Tên doanh nghiệp/ đơn vị phụ thuộc
              </Th>
              <Th styles={{ textAlign: "center" }} rowSpan="2">
                Mã số thuế
              </Th>
              <Th styles={{ textAlign: "center" }} colSpan="2">
                Địa bàn hoạt động sản xuất kinh doanh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Th>
              <Th styles={{ textAlign: "center", width: "150px" }} rowSpan="2">
                Tên mặt hàng xăng dầu
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Đơn vị tính
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Sản lượng xăng dầu do doanh nghiệp/đơn vị phụ thuộc bán ra thuộc đối tượng phải kê
                khai,tính thuế BVMT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tỷ lệ phân bổ (%)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số thuế BVMT phải nộp cho từng tỉnh
              </Th>
            </tr>
            <tr>
              <Th styles={{ textAlign: "center", width: "100px" }}>Tỉnh</Th>
              <Th styles={{ textAlign: "center", width: "100px" }}>Huyện</Th>
              <Th style={{ textAlign: "center" }}>Cơ quan thuế quản lý cấp cục</Th>
              <Th style={{ textAlign: "center" }}>Cơ quan thuế quản lý cấp chi cục</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(1)</Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(2)</Th>
              <Th style={{ textAlign: "center" }}>(3)</Th>
              <Th style={{ textAlign: "center" }}>(4)</Th>
              <Th style={{ textAlign: "center" }}>(5)</Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                (6)
              </Th>
              <Th style={{ textAlign: "center" }}>(7)</Th>
              <Th style={{ textAlign: "center" }}>(8)</Th>
              <Th style={{ textAlign: "center" }}>(9)</Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
            </tr>
          </thead>
          <tbody>
            {data &&
              data.item1.length > 0 &&
              data.item1.map((row, index) => (
                <tr key={row.id.value}>
                  <Td className="toggle-button" style={{ textAlign: "center" }}>
                    {index < 1 ? 1 : index === 1 ? 1 + 0.1 : 1 + 0.1 * index}
                    {row.isDeleted ? (
                      <div className="button-action delete">
                        <button type="button" onClick={() => handleDelete("item1", row.id.value)}>
                          Xóa dòng
                        </button>
                      </div>
                    ) : (
                      <div className="button-action">
                        <button type="button" onClick={() => addNewRow("item1")}>
                          Thêm dòng
                        </button>
                      </div>
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.type.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.type.bg ? (
                      row.type.value
                    ) : row.type?.type === "select" ? (
                      <SelectTable
                        rowType={"item1"}
                        name="type"
                        id={row.id.value}
                        option={typeOption}
                        onChange={handleChange}
                      />
                    ) : (
                      row.type.value
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.companyName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.companyName?.type !== "input" ? (
                      row.companyName.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"text"}
                        id={row.id.value}
                        name="companyName"
                        value={row.companyName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxId.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxId?.type !== "input" ? (
                      row.taxId.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"text"}
                        id={row.id.value}
                        name="taxId"
                        value={row.taxId.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.province.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.province.bg ? (
                      row.province.value
                    ) : row.province?.type === "select" ? (
                      <SelectTable
                        rowType={"item1"}
                        name="province"
                        id={row.id.value}
                        option={provinceOption}
                        onChange={handleChange}
                      />
                    ) : (
                      row.province.value
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.district.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.district.bg ? (
                      row.district.value
                    ) : row.district?.type === "select" ? (
                      <SelectTable
                        rowType={"item1"}
                        name="district"
                        id={row.id.value}
                        option={districtOption}
                        onChange={handleChange}
                      />
                    ) : (
                      row.district.value
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.taxAuthoritiesProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesProvince.bg ? (
                      row.taxAuthoritiesProvince.value
                    ) : row.taxAuthoritiesProvince?.type === "select" ? (
                      <SelectTable
                        rowType={"item1"}
                        name="taxAuthoritiesProvince"
                        id={row.id.value}
                        option={taxAuthoritiesOption}
                        onChange={handleChange}
                      />
                    ) : (
                      row.taxAuthoritiesProvince.value
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.taxAuthoritiesDistrict.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxAuthoritiesDistrict.bg ? (
                      row.taxAuthoritiesDistrict.value
                    ) : row.taxAuthoritiesDistrict?.type === "select" ? (
                      <SelectTable
                        rowType={"item1"}
                        name="taxAuthoritiesDistrict"
                        id={row.id.value}
                        option={taxAuthoritiesOption}
                        onChange={handleChange}
                      />
                    ) : (
                      row.taxAuthoritiesDistrict.value
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.fuelName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.fuelName?.type !== "input" ? (
                      row.fuelName.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"text"}
                        id={row.id.value}
                        name="fuelName"
                        value={row.fuelName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.DVT.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.DVT?.type !== "input" ? (
                      row.DVT.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}

                        id={row.id.value}
                        name="DVT"
                        value={row.DVT.value}
                        onChange={handleChange}
                        disabled={row.DVT.disabled}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.quantityFuel.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.quantityFuel?.type !== "input" ? (
                      row.quantityFuel.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}

                        id={row.id.value}
                        name="quantityFuel"
                        value={row.quantityFuel.value}
                        onChange={handleChange}
                        disabled={row.quantityFuel.disabled}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.PercentQuantityFuel.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.PercentQuantityFuel?.type !== "input" ? (
                      row.PercentQuantityFuel.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}

                        id={row.id.value}
                        name="PercentQuantityFuel"
                        value={row.PercentQuantityFuel.value}
                        onChange={handleChange}
                        disabled={row.PercentQuantityFuel.disabled}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.resourceProtectTaxPaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.resourceProtectTaxPaid?.type !== "input" ? (
                      row.resourceProtectTaxPaid.value
                    ) : (
                      <InputTable
                        rowType={"item1"}
                        type={"number"}
                        id={row.id.value}
                        name="resourceProtectTaxPaid"
                        value={row.resourceProtectTaxPaid.value}
                        onChange={handleChange}
                        disabled={true}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="11"
              >
                Tổng cộng theo từng tỉnh
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              >
                1
              </Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="7"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "right", background: "#ddeff3" }}
                colSpan="1"
              >
                0
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              >
                1.1
              </Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="7"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "right", background: "#ddeff3" }}
                colSpan="1"
              >
                0
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="10"
              >
                Tổng cộng
              </Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "right", background: "#ddeff3" }}
                colSpan="1"
              >
                0
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              >
                1
              </Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "center", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="7"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "left", background: "#ddeff3" }}
                colSpan="1"
              ></Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "right", background: "#ddeff3" }}
                colSpan="1"
              >
                0
              </Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "right", background: "#ddeff3" }}
                colSpan="1"
              >
                0
              </Td>
              <Td
                className="toggle-button"
                style={{ textAlign: "right", background: "#ddeff3" }}
                colSpan="1"
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type, rowType });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name, type, rowType });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, rowType, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type, rowType });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
